[
    {
        "id": "enotria",
        "name": "Accademia Enotria",
        "url": "https://aakraos.github.io/AccademiaEnotria/",
        "image": "assets/img/work-enotria.webp",
        "centerX": 0.30,
        "centerY": 0.25,
        "nodes": [
            {
                "x": 10,
                "y": 35,
                "size": 7
            },
            {
                "x": -30,
                "y": -5,
                "size": 4
            },
            {
                "x": -52,
                "y": -28,
                "size": 3
            },
            {
                "x": -18,
                "y": -42,
                "size": 3
            },
            {
                "x": 22,
                "y": -50,
                "size": 4
            },
            {
                "x": 55,
                "y": -30,
                "size": 3
            },
            {
                "x": 60,
                "y": 8,
                "size": 3
            },
            {
                "x": -8,
                "y": 10,
                "size": 2
            }
        ],
        "connections": [
            [
                2,
                1
            ],
            [
                1,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                1,
                7
            ],
            [
                7,
                0
            ],
            [
                5,
                6
            ],
            [
                6,
                0
            ]
        ]
    },
    {
        "id": "dndtool",
        "name": "D&D MultiTool",
        "url": "https://aakraos.github.io/dndtool/",
        "image": "assets/img/DndToolLogo.webp",
        "centerX": 0.70,
        "centerY": 0.25,
        "nodes": [
            {
                "x": 0,
                "y": 28,
                "size": 7
            },
            {
                "x": -28,
                "y": -2,
                "size": 3
            },
            {
                "x": 28,
                "y": -8,
                "size": 3
            },
            {
                "x": -38,
                "y": -30,
                "size": 3
            },
            {
                "x": 20,
                "y": -40,
                "size": 4
            },
            {
                "x": -10,
                "y": -55,
                "size": 3
            },
            {
                "x": -46,
                "y": 14,
                "size": 2
            },
            {
                "x": 42,
                "y": 14,
                "size": 2
            }
        ],
        "connections": [
            [
                0,
                1
            ],
            [
                0,
                2
            ],
            [
                1,
                3
            ],
            [
                2,
                4
            ],
            [
                3,
                5
            ],
            [
                4,
                5
            ],
            [
                1,
                6
            ],
            [
                2,
                7
            ]
        ]
    },
    {
        "id": "arcadia",
        "name": "Arcadia",
        "url": "https://thearcadiaworld.com",
        "image": "assets/img/logoS-W.webp",
        "centerX": 0.20,
        "centerY": 0.50,
        "nodes": [
            {
                "x": -52,
                "y": 18,
                "size": 5
            },
            {
                "x": -24,
                "y": -10,
                "size": 4
            },
            {
                "x": 0,
                "y": 8,
                "size": 6
            },
            {
                "x": 28,
                "y": -14,
                "size": 4
            },
            {
                "x": 55,
                "y": 10,
                "size": 3
            },
            {
                "x": -38,
                "y": 38,
                "size": 2
            },
            {
                "x": 14,
                "y": 30,
                "size": 2
            }
        ],
        "connections": [
            [
                0,
                1
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                0,
                5
            ],
            [
                2,
                6
            ]
        ]
    },
    {
        "id": "soon1",
        "name": "Coming Soon",
        "url": "#0",
        "image": "assets/img/logoS-W.webp",
        "centerX": 0.80,
        "centerY": 0.50,
        "nodes": [
            {
                "x": 0,
                "y": 0,
                "size": 6
            },
            {
                "x": 2,
                "y": 28,
                "size": 4
            },
            {
                "x": -32,
                "y": 30,
                "size": 3
            },
            {
                "x": 36,
                "y": 26,
                "size": 3
            },
            {
                "x": 4,
                "y": 58,
                "size": 5
            },
            {
                "x": -10,
                "y": 44,
                "size": 2
            },
            {
                "x": 22,
                "y": 10,
                "size": 2
            }
        ],
        "connections": [
            [
                0,
                1
            ],
            [
                1,
                4
            ],
            [
                2,
                1
            ],
            [
                1,
                3
            ],
            [
                0,
                6
            ],
            [
                1,
                5
            ]
        ]
    },
    {
        "id": "soon2",
        "name": "Coming Soon",
        "url": "#0",
        "image": "assets/img/logoS-W.webp",
        "centerX": 0.30,
        "centerY": 0.75,
        "nodes": [
            {
                "x": -18,
                "y": -42,
                "size": 3
            },
            {
                "x": 8,
                "y": -48,
                "size": 3
            },
            {
                "x": -4,
                "y": -28,
                "size": 6
            },
            {
                "x": -2,
                "y": -10,
                "size": 3
            },
            {
                "x": 6,
                "y": 8,
                "size": 3
            },
            {
                "x": 18,
                "y": 22,
                "size": 3
            },
            {
                "x": 28,
                "y": 34,
                "size": 2
            },
            {
                "x": 22,
                "y": 46,
                "size": 2
            },
            {
                "x": 10,
                "y": 54,
                "size": 3
            },
            {
                "x": -2,
                "y": 58,
                "size": 4
            }
        ],
        "connections": [
            [
                0,
                2
            ],
            [
                1,
                2
            ],
            [
                2,
                3
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                5,
                6
            ],
            [
                6,
                7
            ],
            [
                7,
                8
            ],
            [
                8,
                9
            ]
        ]
    },
    {
        "id": "soon3",
        "name": "Coming Soon",
        "url": "#0",
        "image": "assets/img/logoS-W.webp",
        "centerX": 0.70,
        "centerY": 0.75,
        "nodes": [
            {
                "x": -28,
                "y": -46,
                "size": 5
            },
            {
                "x": 30,
                "y": -38,
                "size": 3
            },
            {
                "x": -14,
                "y": -18,
                "size": 2
            },
            {
                "x": -20,
                "y": 0,
                "size": 3
            },
            {
                "x": 0,
                "y": -4,
                "size": 3
            },
            {
                "x": 20,
                "y": 2,
                "size": 3
            },
            {
                "x": 10,
                "y": -20,
                "size": 2
            },
            {
                "x": -24,
                "y": 28,
                "size": 3
            },
            {
                "x": 32,
                "y": 36,
                "size": 5
            },
            {
                "x": 2,
                "y": 20,
                "size": 2
            }
        ],
        "connections": [
            [
                0,
                2
            ],
            [
                2,
                3
            ],
            [
                1,
                6
            ],
            [
                6,
                5
            ],
            [
                3,
                4
            ],
            [
                4,
                5
            ],
            [
                3,
                9
            ],
            [
                9,
                7
            ],
            [
                5,
                9
            ],
            [
                9,
                8
            ]
        ]
    }
]